export enum IconTypeEnum {
    ICON_DEFAULT = 'icon_default',
    ICON_CUSTOM = 'icon_custom',
    IMAGE = 'image',
}
